module.exports = __webpack_public_path__ + "img/bg8.c68ef93a.png";